import { API } from ".";
import { retryFetchSession } from "./session";

export const GET_REGISTRATION_REQUEST = "@@registration/GET_REGISTRATION_REQUEST";
export const GET_REGISTRATION_SUCCESS = "@@registration/GET_REGISTRATION_SUCCESS";
export const GET_REGISTRATION_FAILURE = "@@registration/GET_REGISTRATION_FAILURE";

const is401 = (error) =>
  error?.response?.statusCode === 401 ||
  error?.$metadata?.httpStatusCode === 401 ||
  error?.status === 401;

export function getRegistration() {
  return async (dispatch) => {
    dispatch({
      type: GET_REGISTRATION_REQUEST,
    });
    try {
      const response = await API.get("cmsAPI", "/registration");
      dispatch({
        type: GET_REGISTRATION_SUCCESS,
        payload: response,
      });
      return response;
    } catch (error) {
      if (is401(error)) {
        dispatch(retryFetchSession());
      }
      dispatch({
        type: GET_REGISTRATION_FAILURE,
        payload: error,
      });
      return undefined;
    }
  };
}

export const UPDATE_REGISTRATION_REQUEST =
  "@@registration/UPDATE_REGISTRATION_REQUEST";
export const UPDATE_REGISTRATION_SUCCESS =
  "@@registration/UPDATE_REGISTRATION_SUCCESS";
export const UPDATE_REGISTRATION_FAILURE =
  "@@registration/UPDATE_REGISTRATION_FAILURE";

export function updateRegistration(body, onSuccess) {
  return async (dispatch) => {
    dispatch({
      type: UPDATE_REGISTRATION_REQUEST,
    });
    try {
      const init = { body };
      const response = await API.put("cmsAPI", "/registration", init);
      dispatch({
        type: UPDATE_REGISTRATION_SUCCESS,
        payload: response,
      });
      if (onSuccess) {
        onSuccess(response);
      }
      return response;
    } catch (error) {
      if (is401(error)) {
        dispatch(retryFetchSession());
      }
      dispatch({
        type: UPDATE_REGISTRATION_FAILURE,
        payload: error,
      });
      return undefined;
    }
  };
}

export function validateNmi(nmi) {
  return async (dispatch) => {
    try {
      const init = { body: { nmi } };
      const response = await API.post("cmsAPI", "/nmi/validate", init);
      return response;
    } catch (error) {
      if (is401(error)) {
        dispatch(retryFetchSession());
      }
      return undefined;
    }
  };
}

export const AUTHORISATION_RETRY_REQUEST =
  "@@registration/AUTHORISATION_RETRY_REQUEST";
export const AUTHORISATION_RETRY_SUCCESS =
  "@@registration/AUTHORISATION_RETRY_SUCCESS";
export const AUTHORISATION_RETRY_FAILURE =
  "@@registration/AUTHORISATION_RETRY_FAILURE";

export function retryAuthorisation(registration) {
  return async (dispatch) => {
    dispatch({
      type: AUTHORISATION_RETRY_REQUEST,
    });
    try {
      const init = { body: { status: "authorisation_retry" } };
      const response = await API.put(
        "cmsAPI",
        `/registration/${registration.owner}/${registration.id}`,
        init
      );
      dispatch({
        type: AUTHORISATION_RETRY_SUCCESS,
        payload: response,
      });
      return response;
    } catch (error) {
      if (is401(error)) {
        dispatch(retryFetchSession());
      }
      dispatch({
        type: AUTHORISATION_RETRY_FAILURE,
        payload: error,
      });
      return undefined;
    }
  };
}

export const CLEAR_REGISTRATION = "@@registration/CLEAR_REGISTRATION";

export function clearRegistration() {
  return async (dispatch) => {
    dispatch({
      type: CLEAR_REGISTRATION,
    });
  };
}
